import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ADMIN_ROLE_ID } from "../helpers/constants"

const useCheckPermission = (type, route) => {

    const [allowed, setAllowed] = useState(false);

    const user = useSelector(x => x?.login?.userData) || {};
    const permissions = user?.roleDetails?.permissions || [];

    useEffect(() => {

        const hasPermission = user?.roleDetails?._id === ADMIN_ROLE_ID || permissions.some(permission =>
            permission?.type === type &&
            permission?.permissions?.some(routePermission => routePermission.label === route && routePermission.value)
        );

        setAllowed(hasPermission);
    }, [type, route, permissions]);

    return allowed;
};

export default useCheckPermission;